import { formatDateTime } from "@/lib/helpers";
import { cn } from "@/lib/utils";

/**
 * A single row inside the NotificationBell dropdown. Extracted from
 * NotificationBell.js so the parent stays focused on data loading/state
 * and this component owns only presentation for one notification.
 */
export const NotificationListItem = ({ notification, onSelect }) => {
  return (
    <button
      onClick={() => onSelect(notification)}
      className={cn(
        "w-full text-left px-4 py-3 hover:bg-accent transition-colors",
        !notification.read && "bg-[hsl(var(--role-accent))]/5"
      )}
      data-testid="notification-item"
    >
      <div className="flex items-start gap-2">
        {!notification.read && <span className="h-2 w-2 rounded-full bg-[hsl(var(--role-accent))] mt-1.5 shrink-0" />}
        <div className={cn("min-w-0", notification.read && "pl-4")}>
          <p className="text-sm font-medium truncate">{notification.title}</p>
          <p className="text-xs text-muted-foreground line-clamp-2">{notification.message}</p>
          <p className="text-[11px] text-muted-foreground mt-0.5">{formatDateTime(notification.created_at)}</p>
        </div>
      </div>
    </button>
  );
};
